import React from "react";
import { Route, Routes } from "react-router-dom";
import Admin from "./pages/Admin";
import OnboardingPage from "./pages/Onboarding-page";
import SignUpPage from "./pages/Sign-up-page";
import LoginPage from "./pages/login-page";
import ForgotPassword from "./pages/Forgot-Password";
import AccountDetails from "./pages/AccountDetails";
import Overview from "./pages/Overview";
import StreamsPage from "./pages/StreamsPage";
import TransfersPage from "./pages/TransfersPage";
import AddStreamPage from "./pages/AddStreamPage";
import StreamRequestsAdmin from "./pages/StreamRequestsAdmin";
import AuthenticatedRoute from "./components/AuthenticatedRoute";
import { HashRouter } from "react-router-dom";
import { StreamsProvider } from "./hooks/useStreams";
import { analytics } from "./firebase";
import Instructions from "./pages/Instructions";
import TranscriptHistory from "./pages/TranscriptHistory";
import Audience from "./pages/Audience";
import Glossary from "./pages/Glossary";
import QuestionsPage from "./pages/QuestionsPage";
import NetworkingPage from "./pages/NetworkingPage";
import AdvancedSettings from "./pages/AdvancedSettings";
import Referrals from "./pages/Referrals";
import Billing from "./pages/Billing";
import ReferralsAdmin from "./pages/ReferralsAdmin";
import { useURLLanguage } from "./hooks/useURLLanguage";
const exampleName = "Your Name";
const exampleImageUrl =
  "https://deafassistant.com/londonmosque/images/logo-light.png";
const exampleQrCodeData = "Some QR Code Data";

const App: React.FC = () => {
  // Handle URL-based language detection
  useURLLanguage();

  analytics.app.automaticDataCollectionEnabled = true;
  return (
    <HashRouter>
      <StreamsProvider>
      <Routes>
        {/* Public routes */}
        <Route path="/Signup" element={<SignUpPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/forgetPassword" element={<ForgotPassword />} />

        {/* Protected routes inside AuthenticatedRoute */}
        <Route
          path="/"
          element={
            <AuthenticatedRoute>
              <Overview
                name={exampleName}
                imageUrl={exampleImageUrl}
                qrCodeData={exampleQrCodeData}
              />
            </AuthenticatedRoute>
          }
        />
        <Route
          path="/streams"
          element={
            <AuthenticatedRoute>
              <StreamsPage />
            </AuthenticatedRoute>
          }
        />
        <Route
          path="/transfers"
          element={
            <AuthenticatedRoute>
              <TransfersPage />
            </AuthenticatedRoute>
          }
        />
        <Route
          path="/streams/new"
          element={
            <AuthenticatedRoute>
              <AddStreamPage />
            </AuthenticatedRoute>
          }
        />
        <Route
          path="/stream-requests"
          element={
            <AuthenticatedRoute>
              <StreamRequestsAdmin />
            </AuthenticatedRoute>
          }
        />
        <Route
          path="/profile"
          element={
            <AuthenticatedRoute>
              <AccountDetails />
            </AuthenticatedRoute>
          }
        />
        <Route
          path="/instructions"
          element={
            <AuthenticatedRoute>
              <Instructions />
            </AuthenticatedRoute>
          }
        />
        <Route
          path="/transcript-history"
          element={
            <AuthenticatedRoute>
              <TranscriptHistory />
            </AuthenticatedRoute>
          }
        />
        <Route
          path="/audience"
          element={
            <AuthenticatedRoute>
              <Audience />
            </AuthenticatedRoute>
          }
        />
        <Route
          path="/glossary"
          element={
            <AuthenticatedRoute>
              <Glossary />
            </AuthenticatedRoute>
          }
        />
        <Route
          path="/questions"
          element={
            <AuthenticatedRoute>
              <QuestionsPage />
            </AuthenticatedRoute>
          }
        />
        <Route
          path="/networking"
          element={
            <AuthenticatedRoute>
              <NetworkingPage />
            </AuthenticatedRoute>
          }
        />
        <Route
          path="/advanced-settings"
          element={
            <AuthenticatedRoute>
              <AdvancedSettings />
            </AuthenticatedRoute>
          }
        />
        <Route
          path="/billing"
          element={
            <AuthenticatedRoute>
              <Billing />
            </AuthenticatedRoute>
          }
        />
        <Route
          path="/referrals"
          element={
            <AuthenticatedRoute>
              <Referrals />
            </AuthenticatedRoute>
          }
        />
        <Route
          path="/referrals-admin"
          element={
            <AuthenticatedRoute>
              <ReferralsAdmin />
            </AuthenticatedRoute>
          }
        />
        <Route path="/admin" element={<Admin />} />
        <Route
          path="/onboarding"
          element={
            <AuthenticatedRoute>
              <OnboardingPage />
            </AuthenticatedRoute>
          }
        />
        {/* Add other routes as needed */}
      </Routes>
      </StreamsProvider>
    </HashRouter>
  );
};

export default App;
